import React from 'react';

import {
  useAuth,
} from '../features/auth/AuthContext';

import ResourceLibraryPage
  from '../features/resources/ResourceLibraryPage';

import {
  FullPageLoader,
} from '../features/system/state/StatePage';


export default function ResourceAccessRoute() {
  const {
    status,
  } =
    useAuth();

  if (
    status === 'loading'
  ) {
    return (
      <FullPageLoader />
    );
  }

  return (
    <ResourceLibraryPage />
  );
}